import { uuid } from './uuid'

/**
 * parse string to K/V object function
 * Example: `var strObj = parseStr(params)`
 * @param {String} string of data in query format
 * @return {Array|Object} decoded data in Object format or empty array
 */
export function parseStr (str) {
  if (str) {
    var changeObject = {};
    var arr = [];
    // 将字符串以&为分割点转换成数组
    arr = str.split('&');
    // 此处过滤掉无效参数，兼容url结尾& 【hasModifiy】
    arr = arr.filter(x => /\w+=\w*/.test(x));
    // 循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
    for (var i = 0; i < arr.length; i++) {
      changeObject[arr[i].split('=')[0].toLowerCase()] = arr[i].split('=')[1];
    }
    return changeObject;
  } else {
    return [];
  }
}

/**
 * 检测并格式化本地存储的uv数据
 *
 * @param {string} str 本地存储的uv数据字符串
 * @return {string|object}  返回格式化后的数据
 */
export function checkStorageFormat(str) {
  if (!str) {
    return false
  }
  try {
    const arr = str.split('.')
    const timerStr = arr.pop()
    const id = arr.join('.');
    if (id && timerStr) {
      const timer = Number(timerStr.replace(/-/g, ''))
      if (timer) {
        return {id, timer}
      }
    }
    return false
  } catch (err) {
    return false
  }
}

/**
 * 根据用户传递的配置参数生成uvid字符串
 * @param {String | Function} uvConfig - uv配置参数
 * @return {String} uvid
 */
export function randomUvStr(uvConfig) {
  let uvid = ''
  if (typeof uvConfig === 'string') {
    uvid = uvConfig
  } else if (typeof uvConfig === 'function') {
    uvid = uvConfig()
    if (!uvid) {
      console.warn('Uv config function is empty!')
    }
  } else {
    // 默认生成uuid，前缀添加$识别符
    uvid = '$'+uuid()
  }
  return uvid
}

/**
 * 格式化时间字符串为 20220101
 * @export
 * @param {*} timer
 * @return {string} 格式化后的字符串
 */
export function formatTimer(timer) {
  const year = timer.getFullYear()
  const month = timer.getMonth() + 1
  const day = timer.getDate()
  return [year, (month<10?('0'+month):month), (day<10?('0'+day):day)].join('')
}

/**
 * 根据字符串格式化成对应的时间格式
 *
 * @export
 * @param {*} timerStr
 * @return {*} 
 */
export function getTimerByStr (timerStr) {
  let timerArr = String(timerStr).split('')
  timerArr.splice(6, 0, '-')
  timerArr.splice(4, 0, '-')
  timerArr = timerArr.join('')
  return new Date(timerArr)
}